import { createTheme, Theme } from '@mui/material/styles'
import { colors } from 'constants/colors'


export const DARK_THEME: Theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: colors.RICH_BLACK,
    }
  }
})

export const LIGHT_THEME: Theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: colors.MOONSTONE,
    }
  }
})
